export const DORMITORY_VERSION_LEGACY = 1;
export const DORMITORY_VERSION_SCHEDULING = 2;

/** Scheduling-based dormitory module (v2+). Cloud reads `samad.dormitoryVersion` from universities.json; on-premise maps env `REACT_APP_DORMITORY_VERSION`. */
export function isNewVersion(university: UniversityEntity | null | undefined): boolean {
  return university?.samad?.dormitoryVersion >= DORMITORY_VERSION_SCHEDULING;
}
